﻿/* global require */
(function ($) {
    $(document).ready(function () {
        $.gevent.subscribe($('body'), 'ready-efw', function () {
            // only act on the FTRC4U page
            if (0 == $('.aca-wrap').length) {
                return;
            }

            var Cookies = require('js-cookie');
            var $vars = new Array();
            var $old_cookies = ["find_profile", "find_read"];
            var COOKIE_NAME = "find_profile1";
            var COOKIE_READ = "find_read1";
            var COOKIE_SCOPE = { expires: 365, path: '/' };
            var $reads = new Array();
            function dollars(n) {
                return "$" + n.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");    // thousands comma replacement
            }
            function pct(n) {
                return (n * 100.0).toFixed(0) + "%";
            }
            function fixInputs() {
            }
            function collectVars() {
                var $data = new Object();
                $vars.length = 0;
                $('.aca-ui :text').each(function () {
                    $data[$(this).attr('id')] = $vars[$(this).attr('id')] = Number($(this).val());
                });
                $('.aca-ui select').each(function () {
                    $data[$(this).attr('id')] = $vars[$(this).attr('id')] = Number($(this).val());
                });
                $('.aca-ui input:checkbox').each(function () {
                    $data[$(this).attr('id')] = $vars[$(this).attr('id')] = ($(this).prop('checked') ? 1 : 0);
                });
                $('.paramScoop span').each(function () {
                    $vars[$(this).attr('name')] = ("_" == $(this).attr('name')[0] ? $(this).text() : Number($(this).text().replace(/[^0-9\.]+/g, "")));
                });
                Cookies.set(COOKIE_NAME, JSON.stringify($data), COOKIE_SCOPE);
            }
            function restoreVars() {
                var $data = null;
                try {
                    $data = JSON.parse(Cookies.get(COOKIE_NAME));
                    $('.aca-ui :text').each(function () {
                        $(this).val($data[$(this).attr('id')]);
                    });
                    $('.aca-ui input:checkbox').each(function () {
                        $(this).prop('checked', $data[$(this).attr('id')]);
                    });
                    $('.aca-ui select').each(function () {
                        $(this).val($data[$(this).attr('id')]);
                    });
                } catch (e) {
                    return false;
                }

                return (null != $data);
            }
            function deleteOldCookies() {
                $.each($old_cookies, function (i, e) { Cookies.remove(e, COOKIE_SCOPE); });
            }
            function compute(vars) {
                // fpl can be different for each program!
                vars["magi"] = Math.max(0, vars["qei"]);
                $.each(vars["_fpl-progs"].split('|'), function (i, e) {
                    vars["fpl-" + e] = Math.max(vars["afpl-" + e], vars["afpl-" + e] + (vars["qfam"] - 1) * vars["afpld-" + e]);
                    vars["mfpl-" + e] = Math.max(0, vars["magi"] / vars["fpl-" + e]);
                });
            }
            function print(vars) {
                $(".aca-result-val").each(function () {
                    var $this = $(this), $name = $this.attr("name"), $ref = $this.attr("ref"), val = vars[$name];
                    if ("$" == $ref)
                        val = dollars(val);
                    else if ("%" == $ref)
                        val = pct(val);
                    $this.text(val);
                    //console.log('print: updating name=' + $name);
                });

                // separate functions based on rounding algorithm
                var limitFunctions = {
                    'none': function (val, multiplier) { return val * multiplier; },    // straight percentage
                    'monthly-up': function (val, multiplier) { return Math.ceil((val / 12) * multiplier) * 12; },   // limit is rounded on a monthly basis
                    'monthly-up-5': function (val, multiplier) { return (Math.ceil((val / 12) * (multiplier - .05)) + Math.ceil((val / 12) * (0.05))) * 12; }   // 5% contribution is separately rounded, per month
                };
                $(".aca-result-range").each(function () {
                    var $this = $(this), $var = $this.attr("var"), $min = parseFloat($this.attr("min")), $max = parseFloat($this.attr('max'));
                    var $minLimit = vars[$var] * $min,
                        $maxLimit = vars[$var] * $max;
                    //$this.text(dollars($minLimit));
                    var $root = $this.closest(".tip");
                    $root.find('.aca-result-limit-min').text(dollars($minLimit));
                    $root.find('.aca-result-limit-max').text(dollars($maxLimit));
                    if (vars["magi"] > $minLimit) {
                        $root.find(".aca-result-above-min").removeClass('hidden');
                        $root.find(".aca-result-below-min").addClass('hidden');
                    } else {
                        $root.find(".aca-result-above-min").addClass('hidden');
                        $root.find(".aca-result-below-min").removeClass('hidden');
                    }
                    if (vars['magi'] < $maxLimit) {
                        $root.find(".aca-result-below-max").removeClass('hidden');
                        $root.find(".aca-result-above-max").addClass('hidden');
                    } else {
                        $root.find(".aca-result-below-max").addClass('hidden');
                        $root.find(".aca-result-above-max").removeClass('hidden');
                    }
                    if (vars["magi"] > $minLimit && vars['magi'] < $maxLimit) {
                        $root.find(".aca-result-within").removeClass('hidden');
                        $root.find(".aca-result-without").addClass('hidden');
                    } else {
                        $root.find(".aca-result-within").addClass('hidden');
                        $root.find(".aca-result-without").removeClass('hidden');
                    }
                    //console.log('print: updating range=' + $var);

                });
                $(".aca-result-limit").each(function () {
                    var $this = $(this), $var = $this.attr("var"), $multiplier = parseFloat($this.attr("multiplier")), $rounding = $this.attr('round') || 'none';
                    var $limit = limitFunctions[$rounding](vars[$var], $multiplier);    // implement rounding function if specified
                    $this.text(dollars($limit));
                    var $root = $this.closest(".tip");
                    if (vars["magi"] > $limit) {
                        $root.find(".aca-result-above").removeClass('hidden');
                        $root.find(".aca-result-below").addClass('hidden');
                    } else {
                        $root.find(".aca-result-above").addClass('hidden');
                        $root.find(".aca-result-below").removeClass('hidden');
                    }
                    //console.log('print: updating limit=' + $var);
                });
                $('.aca-result-holder').show();
            }
            function blockEnable(o, b) {
                o.data("state", { enabled: b });
            }
            function fadeBlock(b, t) {
                if (t)
                    b.addClass('select');
                else
                    b.removeClass('select');
            }

            function clearProfileCookie() {
                Cookies.remove(COOKIE_NAME, COOKIE_SCOPE);
            }

            function clearReadCookie() {
                $reads = new Array();
                Cookies.remove(COOKIE_READ, COOKIE_SCOPE);
            }

            function saveReadCookie() {
                if ($reads.length > 0)
                    Cookies.set(COOKIE_READ, JSON.stringify($reads), COOKIE_SCOPE)
            }

            function clearBlocks() {
                $('.aca-block').each(function () {
                    blockEnable($(this), true);
                    fadeBlock($(this), true);
                });
                $('#recommended-reading').hide();
                $('.aca-result-holder').hide();
            }
            // minimal startup = just make sure print variables are reasonable
            function initPrint() {
                fixInputs();
                collectVars();
                compute($vars);
                print($vars);
            }
            function updateBlocks() {
                fixInputs();
                collectVars();
                compute($vars);
                print($vars);
                clearReadCookie();
                $('.aca-block').trigger("compute");
                saveReadCookie();
            }
            function initReading() {
                var $template = "<div class='aca-read-item' name='%id%_read' style='display: none'><div class='aca-read-frame'><div class='aca-read-title'><a href='%href%'><span class='aca-key-token %color-class%'> </span><span class='aca-read-title-inner'>%title%</span></a></div><div class='aca-read-body'></div></div><div class='card-footer'><div class='cta'><span class='cta-prompt'>" + 'general.ui.learnmore'._local() + "</span><span class='cta-go'></span></div></div></div>";
                var $dummy = "<div class='aca-read-item dummy'></div>";
                var $reading = $('#reading');
                $reading.empty();
                $('.aca-block').each(function () {
                    var $this = $(this),
                        id = $this.attr('id'),
                        $par = $this.parent('a'),
                        $href = $par.attr('href'),
                        $hrefs = $this.attr('rel-href'),
                        $read = $this.attr('rel-read') || "",
                        $class_match = /aca-c-([\w]+)/.exec($this.attr('class')),
                        $color_class = (null != $class_match && $class_match.length > 0 ? $class_match[1] : "");
                    $.each($read.split("|"), function (i2, e2) {
                        var $title = $this.attr('rel-title').split("|")[i2];
                        if (!(undefined === $hrefs))
                            $href = $hrefs.split("|")[i2];
                        var $this_template = $template.replace("%id%", id).replace("%color-class%", "aca-c-" + $color_class).replace("%title%", $title).replace("%href%", $href);
                        var $nu = $($this_template);
                        var tipid = e2;
                        // is there a Design Version 3 form of this tip? Note lazy match (.+?) to avoid taking in the suffix too.
                        var tipid3 = e2.replace(/(.+?)(-[A-Z][A-Z])?$/, '$1-3$2');
                        var $tip = ($(tipid3).length > 0 ? $(tipid3) : $(tipid));
                        $nu.find('.aca-read-body').append($tip.clone());
                        $nu.find('a.aca-read-href').attr('href', $href);
                        $nu.prop('read-data', { title: $title, href: $href, 'class': $color_class });
                        $reading.append($nu);
                    });
                });
                // Add a dummy so we can render easily in two columns, if an odd number are to be displayed.
                $reading.append($($dummy));
            }
            //function setupSelects() {
            //    $('.aca-ui select#qfam').selectmenu({ style: 'dropdown', width: 189, format: personFormatting });
            //    $('.aca-ui select#qass').selectmenu({ style: 'dropdown', width: 189, format: rangeFormatting });
            //}

            // super-simple form validation
            function validateInput(e) {
                var $e = $(e.currentTarget);
                var s = $($e).val();
                var $err = $('#' + $e.attr('id') + '-err');
                s = s.replace(/[\s,$]/g, '');
                var n = parseFloat(s);
                if (isNaN(n)) {
                    $err.show();
                    setTimeout(function () { $e.focus(); $e.select(); }, 1); // focus within blur
                    clearBlocks();
                    return false;
                }
                $e.val(n.toFixed(0));
                $err.hide();
                return true;
            }

            // remove old cookies
            deleteOldCookies();

            // intialize reading area
            initReading();

            // set state on load
            clearBlocks();

            // recover settings from cookies
            var $restored = restoreVars();

            // load toggles

            $('.aca-ui :checkbox').bootstrapToggle({
                height: 37,
                on: 'general.ui.yes'._local(),
                off: 'general.ui.no'._local()
            }).bootstrapToggleFixup();

            // react to profile changes
            $('.aca-ui select').change(function () {
                updateBlocks();
            });
            $('.aca-ui input:checkbox').change(function () {
                updateBlocks();
            });
            $('.aca-ui input:text').blur(function (e) {
                if (validateInput(e))
                    updateBlocks();
            }).bind('keypress', function (e) {  // enter key
                var code = e.keyCode || e.which;
                if (13 == code) {
                    $(this).blur();
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
            $('.aca-block[expression]').bind("compute", function () {
                var $this = $(this);
                var $read = "[name=" + $this.attr('id') + "_read]";
                var $expression = $this.attr("expression");
                $expression = $expression.replace(/\$([^\$]*)\$/g, "\$vars[\"$1\"]");
                $expression = $expression.replace(/(\s+)AND(\s+)/g, "$1&&$2");
                $expression = $expression.replace(/(\s+)OR(\s+)/g, "$1||$2");
                $expression = $expression.replace(/(\s+)LT(\s+)/g, "$1<$2");
                $expression = $expression.replace(/(\s+)LE(\s+)/g, "$1<=$2");
                $expression = $expression.replace(/(\s+)GT(\s+)/g, "$1>$2");
                $expression = $expression.replace(/(\s+)GE(\s+)/g, "$1>=$2");
                if (eval($expression)) {
                    blockEnable($this, true);
                    fadeBlock($this, true);
                    $('#recommended-reading').show();
                    $($read).stop(true, true).slideDown(1000);
                    $($read).each(function () {
                        $reads.push($(this).prop('read-data'));
                    });
                } else {
                    blockEnable($this, false);
                    fadeBlock($this, false);
                    $($read).stop(true, true).slideUp(1000);
                }
            });
            $('#clear').on('click', function () {
                $('#aca-form')[0].reset();
                $('.aca-ui input[type=checkbox]').trigger('change');
                clearBlocks();
                clearProfileCookie();
                clearReadCookie();
            });
            $('#options').on('click', function () {
                updateBlocks();
                $('html, body').animate({
                    scrollTop: $('#options_target').is(':visible') ? $('#options_target').offset().top : $('#learn_target').offset().top
                }, 2000);
                return false;
            });
            $('#learn').on('click', function () {
                $('html, body').animate({
                    scrollTop: $('#learn_target').offset().top
                }, 2000);
                return false;
            });
            $('.aca-btn-query').on('click', function () {
                $('html, body').animate({
                    scrollTop: 0
                }, 2000);
                return false;
            });

            // hover
            $('div.aca-hover').each(function () {
                $(this).popover({
                    html: true,
                    template: '<div class="popover finding" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
                    content: function () { return $($(this).attr('rel')).html(); }, // 'Content function called at ' + new Date().toTimeString(); }, // $($(this).attr('rel'))[0],
                    title: ($(this).is('[rel-blocktitle]') > 0 ? $(this).attr('rel-blocktitle') : $(this).attr('rel-title').replace("|", " or ")),
                    placement: 'right',
                    trigger: 'hover'
                });
                //// For debugging!
                //.on('hide.bs.popover', function (e) {
                //    e.preventDefault();
                //    e.stopPropagation();
                //    console.log('preventing close');
                //    return false;
                //});
            });

            // initial display:
            // If  restoring, select appropriate blocks
            // otherwise just make sure replaced variables are shown correctly
            if ($restored)
                updateBlocks();
            else
                initPrint($vars);
        });
    });
})(jQuery);